import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map, take, filter } from 'rxjs';
import { UserService } from '../services/user/user.service';
import { hasPremiumAccess } from '../models/user-profile';

/**
 * Guard to protect premium-only routes
 * Redirects non-premium users directly to the subscription page
 */
@Injectable({
  providedIn: 'root',
})
export class PremiumGuard implements CanActivate {
  private userService = inject(UserService);
  private router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    // Wait for user profile to load (not null) before checking premium status
    return this.userService.userProfile$.pipe(
      filter((profile) => profile !== null),
      take(1),
      map((profile) => {
        if (hasPremiumAccess(profile)) {
          return true;
        }

        // Redirect to subscription page
        return this.router.createUrlTree(['/subscription']);
      })
    );
  }
}

/**
 * Functional guard version for use with canActivate in routing
 */
export const premiumGuard = (): Observable<boolean | UrlTree> => {
  const userService = inject(UserService);
  const router = inject(Router);

  // Wait for user profile to load (not null) before checking premium status
  return userService.userProfile$.pipe(
    filter((profile) => profile !== null),
    take(1),
    map((profile) => {
      if (hasPremiumAccess(profile)) {
        return true;
      }

      // Redirect to subscription page
      return router.createUrlTree(['/subscription']);
    })
  );
};

